const ProductSlider = () => {
    $(window).on('resize load', () => {
        if ($(window).innerWidth() < 1200) {
            $('.featured-products__grid').owlCarousel({
                items: 1,
                margin: 20,
                stagePadding: 50,
                loop: true,
                responsive: {
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            });
        } else {
            $('.featured-products__grid').trigger('destroy.owl.carousel');
        }
    })
}

export default ProductSlider;


// WEBPACK FOOTER //
// ./src/js/app/components/ProductSlider.js